<template>
  <div class="sidebar-details">
    <div class="sidebar-details-header">
      <div class="sidebar-details-close" v-on:click="$store.dispatch('backDetails');">
        <i class="far fa-arrow-alt-circle-left"></i>
      </div>
      <div class="sidebar-details-main-title">{{ hall.properties.nazwa | showInLang(currlang) }}</div>
    </div>
    <div class="sidebar-details-body">
      <div class="sidebar-details-image">
        <div @click="openLightbox">
          <b-carousel id="carousel2" controls :interval="2000" v-model="carouselIndex">
            <template v-for="(url, index) in CarouselImages">
              <b-carousel-slide :key="index" :img-src="url.path + '?thumb=1'" @click="openLightbox"></b-carousel-slide>
            </template>
          </b-carousel>
        </div>
      </div>

      <div class="sidebar-details-first-info">
        <div class="sidebar-details-area-label">{{ $t('nav.infoPanel.hallSurface') }}</div>
        <div
          class="sidebar-details-area-value"
        >{{ hall.properties.pow_m2 }} {{ $t('nav.infoPanel.m2') }}</div>
      </div>

      <SidebarDetailsOptions
        panoramaUrl="http://panorama.invest-park.com.pl/?gps=552fbc6b9c45071d3a1b066e"
        :coordinates="hall.properties.centroid_geometry.coordinates"
        disable-pdf
        @calc="$parent.openModalCalc()"
      />

      <div class="sidebar-details-informations">
        <div class="sidebar-details-title">{{ $t("nav.halls.regData") }}</div>
        <table class="table sidebar-details-informations-table">
          <tbody>
            <tr>
              <td>{{ $t("nav.halls.hallName") }}</td>
              <td>{{ hall.properties.nazwa | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.address") }}</td>
              <td>{{ hall.properties.adres | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.city") }}</td>
              <td>{{ hall.properties.miejscowosc | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.communityName") }}</td>
              <td>{{ hall.properties.gmina_nazwa | removeCommunityName | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.districtName") }}</td>
              <td>{{ hall.properties.powiat_nazwa | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.voivodeshipName") }}</td>
              <td>{{ hall.properties.wojewodztwo_nazwa | showInLangField(currlang) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="sidebar-details-informations">
        <div class="sidebar-details-title">{{ $t("nav.halls.parametersInfrastructure") }}</div>
        <div class="sidebar-details-subtitle">{{ $t("nav.halls.parameters") }}</div>
        <table class="table sidebar-details-informations-table">
          <tbody>
            <tr>
              <td>{{ $t("nav.halls.surface") }}</td>
              <td>{{ hall.properties.pow_m2 | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.height") }}</td>
              <td>{{ hall.properties.wysokosc | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.buildYear") }}</td>
              <td>{{ hall.properties.rok_budowy | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.techStatus") }}</td>
              <td>{{ hall.properties.stan_techniczny | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.maxEmphasis") }}</td>
              <td>{{ hall.properties.maks_nacisk | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.heating") }}</td>
              <td>{{ hall.properties.ogrzewanie | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.parking") }}</td>
              <td>{{ hall.properties.miejsca_parkingowe | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.maneuveringArea") }}</td>
              <td>{{ hall.properties.plac_manewr | showInLang(currlang) }}</td>
            </tr>

            <tr>
              <td>{{ $t("nav.halls.electricity") }}</td>
              <td>{{ hall.properties.prad | showInLang(currlang) }}</td>
            </tr>
          </tbody>
        </table>

        <div class="sidebar-details-subtitle">{{ $t("nav.halls.infrastructure") }}</div>
        <table class="table sidebar-details-informations-table">
          <tbody>
            <tr>
              <td>{{ $t("nav.halls.electricity") }}</td>
              <td>{{ hall.properties.prad | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.water") }}</td>
              <td>{{ hall.properties.woda | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.gas") }}</td>
              <td>{{ hall.properties.gaz | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.canal") }}</td>
              <td>{{ hall.properties.kanal | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.rain") }}</td>
              <td>{{ hall.properties.deszcz | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.tele") }}</td>
              <td>{{ hall.properties.tele | showInLang(currlang) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="sidebar-details-contact">
        <div class="sidebar-details-title">{{ $t("nav.halls.contactPerson") }}</div>
        <div class="sidebar-details-contact-item">
          <div
            class="sidebar-details-contact-avatar"
            v-if="hall.properties.os_kontakt_avatar && hall.properties.os_kontakt_avatar.length"
          >
            <img :src="$parent.imgToSrc(hall.properties.os_kontakt_avatar)" />
          </div>
          <div v-else>{{ hall.properties.os_kontakt_avatar | showInLangAvatar(currlang) }}</div>
          <div class="sidebar-details-contact-info">
            <div
              class="sidebar-details-contact-info-name"
            >{{ $t("nav.halls.name") }} {{ hall.properties.os_kontakt_imie | showInLangField(currlang) }}</div>
            <div
              class="sidebar-details-contact-info-name"
            >{{ $t("nav.halls.surname") }} {{ hall.properties.os_kontakt_nazwisko | showInLangField(currlang) }}</div>
            <div
              class="sidebar-details-contact-info-text"
            >{{ $t("nav.halls.position") }} {{ hall.properties.os_kontakt_stanowisko | showInLangField(currlang) }}</div>
            <div
              class="sidebar-details-contact-info-text"
            >{{ $t("nav.halls.department") }} {{ hall.properties.os_kontakt_departament | showInLangField(currlang) }}</div>
            <div class="sidebar-details-contact-info-phone">
              {{ $t("nav.halls.telFirst") }}
              <a
                :href="'tel:' + hall.properties.os_kontakt_tel_kom"
              >{{ hall.properties.os_kontakt_tel_kom | showInLangField(currlang) }}</a>
            </div>
            <div class="sidebar-details-contact-info-phone">
              {{ $t("nav.halls.telSecond") }}
              <a
                :href="'tel:' + hall.properties.os_kontakt_tel_sluzb"
              >{{ hall.properties.os_kontakt_tel_sluzb | showInLangField(currlang) }}</a>
            </div>
            <div class="sidebar-details-contact-info-mail">
              {{ $t("nav.halls.email") }}
              <a
                :href="'mailto:' + hall.properties.os_kontakt_email"
              >{{ hall.properties.os_kontakt_email | showInLangField(currlang) }}</a>
            </div>
            <div class="sidebar-details-contact-info-options">
              <div
                class="sidebar-details-contact-info-options-item pdf"
                v-tooltip.auto="$t('tooltip.savePDF')"
              >
                <img src="img/pdf_icon.svg" />
              </div>
              <div
                class="sidebar-details-contact-info-options-item qrcode"
                v-tooltip.auto="$t('tooltip.qrcode')"
                @click="$modal.show('qrcode-modal')"
              >
                <img src="img/qr_code_icon.svg" />
              </div>
              <div class="sidebar-details-contact-info-options-item degrees">
                <img src="img/question_mark_icon.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sidebar-details-informations">
        <div class="sidebar-details-ann">
          <div class="sidebar-details-ann-text">{{ $t("nav.infoPanel.add1") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarDetailsOptions from "./SidebarDetailsOptions";

export default {
  components: {
    SidebarDetailsOptions
  },
  data() {
    return {
      carouselIndex: 0,
    }
  },
  computed: {
    hall() {
      return this.$store.getters.currentHala || { properties: {} };
    },
    currlang() {
      return this.$parent.currlang;
    },
    openLightbox() {
      return () => {this.$parent.openLightbox(this.hall.properties.zdjecia, this.carouselIndex)};
    },
    CarouselImages() {
      let CarouselImages = [];
      let zdjecia = this.hall.properties.zdjecia || [];
      if (zdjecia.length == 0) {
        CarouselImages.push({
          path: "img/invest_park_logo_big.png"
        });
      }
      zdjecia.forEach(pathImg => {
        CarouselImages.push({
          path: this.$parent.imgToSrc(pathImg)
        });
      });
      return CarouselImages;
    }
  }
};
</script>
